import React, { useState, useEffect } from 'react';
import ConfirmationForm from './ConfirmationForm';
import ConfirmationFooter from './components/ConfirmationFooter/ConfirmationFooter';
import { profileRepository } from '../../repositories/profileRepository';
import './ConfirmationData.css'; // Import the new CSS

const ConfirmationData = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Os dados pessoais nao ficam no navegador: vem da API, pela sessao.
    const loadUserData = async () => {
      try {
        const response = await profileRepository.getProfile();
        setUserData(response.data);
      } catch (error) {
        console.error('Erro ao buscar dados do usuário:', error);
      }
    };
    loadUserData();
  }, []);

  return (
    <div className="confirmation-data-wrapper">
      <div className="confirmation-data-content">
        <ConfirmationForm userData={userData} />
      </div>
      <ConfirmationFooter />
    </div>
  );
};

export default ConfirmationData;